<template>
  <div>
    <el-table :data="tableList" style="width: 100%" height="630">
      <el-table-column prop="symbol" label="交易对id" />
      <el-table-column prop="qtyRate" label="下单数量比例" />
      <el-table-column prop="dealRate" label="成交数量比例" />
      <el-table-column label="机器人开关">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <el-switch active-color="#13ce66" @change="handleCodeStatusChange(scope.row, $event)"
              :value="scope.row.robotSwitch ? true : false"></el-switch>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="200" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="small" type="primary" circle icon="el-icon-edit"
            @click="handleEdit(scope.$index, scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="编辑" width="400px" :visible.sync="dialogVisible" @close="closeDialog" :before-close="closeDialog">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="下单数量比例" prop="qtyRate">
          <el-input-number :precision="4" :step="0.1" v-model.trim="ruleForm.qtyRate" placeholder="请输入"></el-input-number>
        </el-form-item>
        <el-form-item label="成交数量比例" prop="dealRate">
          <el-input-number :precision="4" :step="0.1" v-model.trim="ruleForm.dealRate"
            placeholder="请输入"></el-input-number>
        </el-form-item>

        <el-form-item label="交易对" prop="symbol">
          <el-select v-model="ruleForm.symbol" disabled class='btn' clearable filterable placeholder="请选择交易对">
            <el-option v-for="item in pairList" :key="item.id" :label="item.symbol" :value="item.symbol">
            </el-option>
          </el-select>
        </el-form-item>


      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import api from '../../api'
export default {
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
      },
      rules: {
        qtyRate: [
          { required: true, message: "请输入下单数量比例", trigger: "blur" },

        ],
        dealRate: [
          { required: true, message: "请输入成交数量比例", trigger: "blur" },

        ],
        symbol: [
          { required: true, message: '请选择交易对', trigger: "blur" },
        ]
      },
    };
  },
  computed: {
    ...mapState("robotSotre", ["tableList", 'pairList']),
  },
  methods: {
    handleEdit(index, row) {
      this.dialogVisible = true;
      this.ruleForm = row
    },
    handleCodeStatusChange(row, status) {
      const message = status
        ? "确认要开启机器人开关吗？"
        : "确认要关闭机器人开关吗？";
      let url = status ? 'switchOn' : 'switchOff'
      this.$confirm(message, "提示", { type: "warning" }).then(() => {
        api[url]({ id: row.id }).then(res => {
          console.log('res', res);
          if (res.code == 0) {
            this.$message.success('操作成功')
            this.$emit('refresh');
          }
        })
      });
    },
    closeDialog() {
      this.$refs.ruleForm.resetFields();
      this.ruleForm = {
      }
      this.dialogVisible = false;
    },
    open() {
      this.dialogVisible = true
    },
    submitForm() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          api.robotUpdate({
            ...this.ruleForm
          }).then(res => {
            if (res.code == 0) {
              this.$message.success('操作成功！');
              this.closeDialog()
              this.$emit('refresh');
            }

          })
        }

      })

    },
  },
};
</script>

<style lang="less" scoped></style>
